const localizeForm = (
  formObject,
  {
    USER_FORM_ORGANIZATION_LABEL,
    USER_FORM_ORGANIZATION_PLACEHOLDER,
    USER_FORM_ORGANIZATION_ERROR,
    USER_FORM_SUBORGANIZATION_LABEL,
    USER_FORM_SUBORGANIZATION_PLACEHOLDER,
    USER_FORM_SUBORGANIZATION_ERROR,
    USER_FORM_CLASS_LABEL,
    USER_FORM_CLASS_PLACEHOLDER,
    USER_FORM_CLASS_ERROR,
    USER_FORM_EMAIL_LABEL,
    USER_FORM_EMAIL_PLACEHOLDER,
    USER_FORM_EMAIL_ERROR,
    USER_FORM_USER_TYPE_LABEL,
    USER_FORM_USER_TYPE_PLACEHOLDER,
    USER_FORM_USER_TYPE_ERROR,
    USER_FORM_NAME_LABEL,
    USER_FORM_NAME_PLACEHOLDER,
    USER_FORM_NAME_ERROR,
    USER_FORM_SURNAME_LABEL,
    USER_FORM_SURNAME_PLACEHOLDER,
    USER_FORM_SURNAME_ERROR,
    USER_FORM_NICKNAME_LABEL,
    USER_FORM_NICKNAME_PLACEHOLDER,
    USER_FORM_NICKNAME_ERROR,
    USER_FORM_STUDENTNO_LABEL,
    USER_FORM_STUDENTNO_PLACEHOLDER,
    USER_FORM_STUDENTNO_ERROR,
    USER_FORM_ALL_BOOKS_ENABLED_LABEL,
    USER_FORM_ALL_BOOKS_ENABLED_PLACEHOLDER,
    USER_FORM_ALL_BOOKS_ENABLED_ERROR,
  }
) => {
  const updatedForm = {
    ...formObject,
    formField: {
      ...formObject.formField,
      organization: {
        ...formObject.formField.organization,
        label: USER_FORM_ORGANIZATION_LABEL ?? formObject.formField.organization.label,
        placeholder:
          USER_FORM_ORGANIZATION_PLACEHOLDER ?? formObject.formField.organization.placeholder,
        errorMsg: USER_FORM_ORGANIZATION_ERROR ?? formObject.formField.organization.errorMsg,
      },
      subOrganization: {
        ...formObject.formField.subOrganization,
        label: USER_FORM_SUBORGANIZATION_LABEL ?? formObject.formField.subOrganization.label,
        placeholder:
          USER_FORM_SUBORGANIZATION_PLACEHOLDER ?? formObject.formField.subOrganization.placeholder,
        errorMsg: USER_FORM_SUBORGANIZATION_ERROR ?? formObject.formField.subOrganization.errorMsg,
      },
      classData: {
        ...formObject.formField.classData,
        label: USER_FORM_CLASS_LABEL ?? formObject.formField.classData.label,
        placeholder: USER_FORM_CLASS_PLACEHOLDER ?? formObject.formField.classData.placeholder,
        errorMsg: USER_FORM_CLASS_ERROR ?? formObject.formField.classData.errorMsg,
      },
      email: {
        ...formObject.formField.email,
        label: USER_FORM_EMAIL_LABEL ?? formObject.formField.email.label,
        placeholder: USER_FORM_EMAIL_PLACEHOLDER ?? formObject.formField.email.placeholder,
        errorMsg: USER_FORM_EMAIL_ERROR ?? formObject.formField.email.errorMsg,
      },
      userType: {
        ...formObject.formField.userType,
        label: USER_FORM_USER_TYPE_LABEL ?? formObject.formField.userType.label,
        placeholder: USER_FORM_USER_TYPE_PLACEHOLDER ?? formObject.formField.userType.placeholder,
        errorMsg: USER_FORM_USER_TYPE_ERROR ?? formObject.formField.userType.errorMsg,
      },
      name: {
        ...formObject.formField.name,
        label: USER_FORM_NAME_LABEL ?? formObject.formField.name.label,
        placeholder: USER_FORM_NAME_PLACEHOLDER ?? formObject.formField.name.placeholder,
        errorMsg: USER_FORM_NAME_ERROR ?? formObject.formField.name.errorMsg,
      },
      surname: {
        ...formObject.formField.surname,
        label: USER_FORM_SURNAME_LABEL ?? formObject.formField.surname.label,
        placeholder: USER_FORM_SURNAME_PLACEHOLDER ?? formObject.formField.surname.placeholder,
        errorMsg: USER_FORM_SURNAME_ERROR ?? formObject.formField.surname.errorMsg,
      },
      nickName: {
        ...formObject.formField.nickName,
        label: USER_FORM_NICKNAME_LABEL ?? formObject.formField.nickName.label,
        placeholder: USER_FORM_NICKNAME_PLACEHOLDER ?? formObject.formField.nickName.placeholder,
        errorMsg: USER_FORM_NICKNAME_ERROR ?? formObject.formField.nickName.errorMsg,
      },
      studentNo: {
        ...formObject.formField.studentNo,
        label: USER_FORM_STUDENTNO_LABEL ?? formObject.formField.studentNo.label,
        placeholder: USER_FORM_STUDENTNO_PLACEHOLDER ?? formObject.formField.studentNo.placeholder,
        errorMsg: USER_FORM_STUDENTNO_ERROR ?? formObject.formField.studentNo.errorMsg,
      },
      allBooksEnabled: {
        ...formObject.formField.allBooksEnabled,
        label: USER_FORM_ALL_BOOKS_ENABLED_LABEL ?? formObject.formField.allBooksEnabled.label,
        placeholder:
          USER_FORM_ALL_BOOKS_ENABLED_PLACEHOLDER ??
          formObject.formField.allBooksEnabled.placeholder,
        errorMsg:
          USER_FORM_ALL_BOOKS_ENABLED_ERROR ?? formObject.formField.allBooksEnabled.errorMsg,
      },
    },
  };

  return updatedForm;
};

export default localizeForm;
